export const baseURL = 'https://dmi.allsoftbooks.com/ecomm/api/'
